
import { Component, Vue, Prop } from 'vue-property-decorator'
import LocationMapMapbox from './LocationMapMapbox.vue'
import { MarkerPosition } from '@/types//Maps'
import userInfoStore from '@/store/userInfo'
import { MapProvider } from '@/types//Auth'
import config from '@/config'

@Component({
  components: {
    LocationMapMapbox
  }
})
export default class LocationMap extends Vue {
  @Prop({ required: true })
  location: MarkerPosition

  /** Optional prop to display more than one location */
  @Prop({ required: false })
  locations: MarkerPosition[]

  @Prop({ required: false })
  refLocation: MarkerPosition

  mapProvider: MapProvider = userInfoStore.userInfo.domain.mapProvider
  MapProvider = MapProvider

  get isRefLocationVisible () {
    return this.refLocation && (this.location.lat.toString() + this.location.lng.toString()) !== (this.refLocation.lat.toString() + this.refLocation.lng.toString())
  }

  getPublicImgPath (path: string) {
    return config.basePath + path
  }

  getLocationDistanceText (locationA: MarkerPosition, locationB: MarkerPosition) {
    return `Distancia: ${locationA.haversineDistance(locationB).toFixed(2)} KM`
  }
}
